import React, { Component } from 'react';
import { Navbar, Nav, Container, Row} from "react-bootstrap";
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import objects from "./App.data.json"
import {Link} from "react-router-dom"
import Page1 from './Components/Page1';
import EventDetails from './Components/EventDetails';
import EventPage from './Components/EventPage';
import ProjectPage from './Components/ProjectPage';
import ProjectDetails from './Components/ProjectDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faMapMarkerAlt,faEnvelope,faPhoneAlt, faHome, faUsers, faProjectDiagram,faCalendarCheck, faBullhorn, faUserAlt, faUserAltSlash, faBell, faArrowAltCircleUp} from "@fortawesome/free-solid-svg-icons";
import {faFacebook,faInstagram,faLinkedin} from '@fortawesome/free-brands-svg-icons'
import classes from './App.module.css'
import dataset from './Components/projects.json'
import data from "./Components/events.json" 
import LoginPage from './Components/LoginPage';
import ContactUs from './Components/ContactUs';
import UpdatePage from './Components/UpdatePage';
import './App.css';
import axios from 'axios'
import details from './Components/page1.data.json'
// import Team from './Team/Team'
import TeamPage from "./Components/TeamPage";
import alumnidetails from "./Components/alumni.json";
import juniorsdetails from "./Components/juniors.json";
import seniorsdetails from "./Components/seniors.json";
import {faHandshake, faUser } from '@fortawesome/free-regular-svg-icons';
import Announcement from './Components/Announcement';
import Subscribe from './Components/Subscribe';

class App extends Component {
    constructor(){
      super();
      this.state={
        num:0,
        projects: dataset,
        events:data,
        about:details,
        alumni:alumnidetails,
        seniors:seniorsdetails,
        juniors:juniorsdetails,
        ContactmodalShow:false,
        LoginmodalShow:false,
        isLoggedIn: false,
        subscribeShow:false,
        teampic:"https://dl.dropboxusercontent.com/s/157843ml9zhnixe/group.jpg?dl=0"
      }
    }
  fun=(obj1)=>{
    console.log(obj1)
    this.setState({num:obj1},()=>{
      console.log(this.state.num)
    }) 
  }

  componentDidMount(){
    const proxyurl = "https://cors-anywhere.herokuapp.com/";
    console.log('renderinng now')
    // axios.get('https://mysterious-scrubland-14862.herokuapp.com/api/v1/Home/Projects')
    axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Projects?sort=date')
        .then(response =>{
            // console.log(response.data.data.projects)
            response.data.data.projects.reverse();
            this.setState({projects: response.data.data.projects})
            // this.props.update(response.data.data.projects)
        })
        .catch(error => {
            console.log(error)
        })

        // axios.get('https://mysterious-scrubland-14862.herokuapp.com/api/v1/Home/Eventgallery')
        axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Eventgallery?sort=-date')
        .then(response =>{
            // console.log(response.data.data.events)
            response.data.data.events.reverse();
            this.setState({events: response.data.data.events})
            // this.props.update(response.data.data.events)
        })
        .catch(error => {
            console.log(error)
        })

        axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/About')
        .then(response =>{
            // console.log(response)
            this.setState({about: response.data.data.about[0]})
            // this.props.update(response.data.data.events)
        })
        .catch(error => {
            console.log(error)
        })

        // axios.get('https://mysterious-scrubland-14862.herokuapp.com/api/v1/Home/Alumni')
        axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Alumni?sort=year')
        .then(response =>{
            // console.log(response)
            this.setState({alumni: response.data.data.alumnis})
            // this.props.update(response.data.data.events)
        })
        .catch(error => {
            console.log(error)
        })

        axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Juniors')
        .then(response =>{
            // console.log(response)
            this.setState({juniors: response.data.data.juniors})
            // this.props.update(response.data.data.events)
        })
        .catch(error => {
            console.log(error)
        })

        axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Seniors')
        .then(response =>{
            // console.log(response)
            this.setState({seniors: response.data.data.seniors})
            // this.props.update(response.data.data.events)
        })
        .catch(error => {
            console.log(error)
        })

        axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/teampic')
        .then(response =>{
            // console.log(response)
            this.setState({teampic: response.data.data.teampic[0].teamimage})
            // this.props.update(response.data.data.events)
        })
        .catch(error => {
            console.log(error)
        })
}

  updateProj=(obj1)=>{
    console.log(obj1)
    this.setState({projects:obj1},()=>{
      console.log(this.state.projects)
    }) 
  }

  updateEvents=(obj1)=>{
    console.log(obj1)
    this.setState({events:obj1},()=>{
      console.log(this.state.events)
    }) 
  }

  setContactModalShow=(bool)=>{
    this.setState({ContactmodalShow:bool})
  }

  setSubscribeShow=(bool)=>{
    this.setState({subscribeShow:bool})
  }

  setLoginModalShow=(bool)=>{
    this.setState({LoginmodalShow:bool})
  }

  validate=(bool)=>{
    this.setState({isLoggedIn:bool})
  }
  message=false

   

  render() {
    // if (!this.state.isLoggedIn) {
    //  this.message=(<Nav.Link onClick={() => this.setLoginModalShow(true)} className={classes.Link} align="right">Login</Nav.Link>
    //                 <LoginPage show={this.state.LoginmodalShow} onHide={() => this.setLoginModalShow(false)} islogged={this.state.isLoggedIn} validate={this.validate}></LoginPage>)
    // }
    return (
      <div className="App" style={{margin:"0px", padding:"0px"}}>
      <Router>
      <div className={classes.contentDisplay}>
        <Navbar collapseOnSelect expand="lg" variant="dark" fixed="top" className={classes.navStyle}> 
          <Container fluid>
          <Navbar.Brand  onClick={()=>{this.fun(1)}} style={{fontSize: '1.5em'}}><Link to="/" className={classes.Link}><img rel="apple-touch-icon" src="logo_without.png" width="60px"/> </Link></Navbar.Brand>
          {/* <FontAwesomeIcon icon={faLightbulb} size='1x'/> */}
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link ><Link to="/" className={classes.Link}><FontAwesomeIcon icon={faHome}/> Home </Link></Nav.Link>
              <Nav.Link ><Link to="/team" className={classes.Link}><FontAwesomeIcon icon={faUsers}/> Team </Link></Nav.Link>
              <Nav.Link ><Link to="/projects" className={classes.Link}><FontAwesomeIcon icon={faProjectDiagram}/> Projects </Link></Nav.Link>
              <Nav.Link ><Link to="/events" className={classes.Link}> <FontAwesomeIcon icon={faCalendarCheck}/> Gallery </Link></Nav.Link>
              <Nav.Link ><Link to="/announcement" className={classes.Link}> <FontAwesomeIcon icon={faBullhorn}/> Announcement </Link></Nav.Link>
              <ContactUs show={this.state.ContactmodalShow} onHide={() => this.setContactModalShow(false)} />
              <Nav.Link onClick={() => this.setContactModalShow(true)} style={{color:"white"}} ><FontAwesomeIcon icon={faHandshake}/> Contact Us </Nav.Link>
              {this.state.isLoggedIn&&(<Nav.Link><Link to="/update" className={classes.Link}><FontAwesomeIcon icon={faArrowAltCircleUp}/> Update </Link></Nav.Link>)}
              </Nav>
              <Nav className="ml-auto">
              <Subscribe show={this.state.subscribeShow} onHide={() => this.setSubscribeShow(false)} />
              <Nav.Link onClick={() => this.setSubscribeShow(true)} style={{color:"white"}} ><FontAwesomeIcon icon={faBell}/> Subscribe </Nav.Link>
              <LoginPage show={this.state.LoginmodalShow} onHide={() => this.setLoginModalShow(false)} islogged={this.state.isLoggedIn.toString()} validate={this.validate}></LoginPage>
              {this.state.isLoggedIn&&(<Nav.Link onClick={() => this.validate(false)} ><Link to="/" className={classes.Link}><FontAwesomeIcon icon={faUserAltSlash}/> Logout</Link></Nav.Link>)}
              {!this.state.isLoggedIn&&(<Nav.Link onClick={() => this.setLoginModalShow(true)} style={{color:"white"}}> <FontAwesomeIcon icon={faUserAlt}/> Login</Nav.Link>)}
            </Nav>
          </Navbar.Collapse>
          </Container>
        </Navbar>

      
        {/* <PageSelector curr={this.state.curr}></PageSelector> */}
        <Switch>
                <Route path="/" exact component={()=>{return(<Page1 about={this.state.about}/>)}} />
                <Route path="/team" exact render={()=>{return(<TeamPage teampic={this.state.teampic} alumni={this.state.alumni} seniors={this.state.seniors} juniors={this.state.juniors}></TeamPage>)}} />
                {/* <Route path="/team" exact render={()=>{return(<Team></Team>)}} /> */}
                <Route path="/projects" exact render={()=>{return(<ProjectPage fun={this.fun} projects={this.state.projects} update={this.updateProj} />)}}/>
                {this.state.projects.map((obs,index)=>{
                  return(
                    <Route path={"/projects/"+index} render={()=>{return(<ProjectDetails num={index} projects={this.state.projects}/>)}}/>
                  );
                })}
                {/* <Route path={"/projects/"+this.state.num} render={()=>{return(<ProjectDetails num={this.state.num} projects={this.state.projects}/>)}}/> */}
                <Route path="/events" exact render={()=>{return(<EventPage fun={this.fun} events={this.state.events} update={this.updateEvents}/>)}}/>
                {this.state.events.map((obs,index)=>{
                  return(
                    <Route path={"/events/"+index} render={()=>{return(<EventDetails num={index} events={this.state.events}/>)}}/>
                  );
                })}
                {/* <Route path={"/events/"+this.state.num} render={()=>{return(<EventDetails num={this.state.num} events={this.state.events}/>)}}/> */}
                {this.state.isLoggedIn&&<Route path="/update" exact render={UpdatePage} />}
                {!this.state.isLoggedIn&&<Route path="/update" render={()=>{return(<div style={{paddingTop:"40px"}}><h1>Sorry Cannot Display Update page</h1><h3>Kindly login to view this page</h3></div>);}} />}
                <Route path="/announcement" exact component={()=>{return(<Announcement isLoggedIn={String(this.state.isLoggedIn)}/>)}} />
        </Switch>
        </div>
      
        <div className={classes.footer}>
          <br></br>
          <Container>
        
           <Row>
             <div className="col-6">
                <h1>{objects.footer[0].title}</h1>
                <br></br>
                  <h5><FontAwesomeIcon icon={faMapMarkerAlt}/>  {objects.footer[0].address}</h5>
                <br></br>
                  <h5><FontAwesomeIcon icon={faEnvelope}/>  {this.state.about.Email}</h5>
                <br></br>
                  <h5><FontAwesomeIcon icon={faPhoneAlt}/>  {this.state.about.Contact}</h5>
             </div>

             <div className="col-6">
              <h1>{objects.footer[1].title}</h1>
              <br></br>
                <h5><Link to="/projects" className={classes.Link}><FontAwesomeIcon icon={faProjectDiagram}/> {objects.footer[1].link1}</Link></h5>
              <br></br>
                <h5><Link to="/events" className={classes.Link}><FontAwesomeIcon icon={faCalendarCheck}/> {objects.footer[1].link2}</Link></h5>
             </div>
           </Row>

           <div align="center">
           <br/><br/>
           <a className={classes.smLink} href={this.state.about.facebook}><FontAwesomeIcon icon={faFacebook} size='3x'style={{margin:'25px'}} /></a>
           <a className={classes.smLink} href={this.state.about.Instagram}><FontAwesomeIcon icon={faInstagram} size='3x'style={{margin:'25px'}} /></a>
           <a className={classes.smLink} href={this.state.about.Linkedin}><FontAwesomeIcon icon={faLinkedin} size='3x'style={{margin:'25px'}} /></a>
          </div>
          </Container>
          
        </div>
        </Router>
      </div>
    );
  }
}

export default App;
